import dayjs from 'dayjs';
import { format } from 'date-fns';
import React from 'react';
import groupBy from 'lodash/groupBy';
import sortBy from 'lodash/sortBy';
import uniq from 'lodash/uniq';
import { Alert, Button } from 'antd';

interface Props {
  selectedTime?: string;
  availableTimes: string[];
  onSelectTime: (time: string) => void;
}

class Timepicker extends React.PureComponent<Props> {
  isSameTime(time: string, compareTime) {
    const timeStr = `0${time}`;
    const compareTimeStr = `0${compareTime}`;

    if (time && compareTime) {
      return timeStr.substring(timeStr.length - 8) === compareTimeStr.substring(compareTimeStr.length - 8);
    }

    return false;
  }

  renderEmptyState() {
    return (
      <div style={{ paddingTop: 30 }}>
        <Alert
          type="warning"
          message="No available time slots on selected day."
        />
      </div>
    );
  }

  renderHours(businessHours: string[] = []) {
    const { selectedTime, onSelectTime } = this.props;
    const oderedHours = sortBy(businessHours, [hour => {
      const currentDay = format(new Date(), 'yyyy-MM-dd');
      const businessDateTime = dayjs(`${currentDay} ${hour}`, 'YYYY-MM-DD HH:mm A').valueOf();
      return businessDateTime;
    }]);

    return oderedHours.map((time: any) => {
      return (
        <Button
          size="large"
          key={`booking-time-${Math.random()}`}
          type={this.isSameTime(time, selectedTime) ? 'primary' : 'default'}
          onClick={() => onSelectTime(time)}
          style={{
            display: 'inline-block',
            marginRight: 10,
            marginTop: 10,
            width: 100,
          }}
        >{time}</Button>
      );
    });
  }

  render() {
    const { availableTimes } = this.props;

    if (availableTimes.length === 0) {
      return this.renderEmptyState();
    }

    const businessHoursGroups = groupBy(uniq(availableTimes), (businessHour: string) => {
      return businessHour.indexOf('AM') > -1;
    });
    const morningHours = businessHoursGroups[true];
    const afternoonHours = businessHoursGroups[false];

    return (
      <div style={{ paddingTop: 30 }}>
        {morningHours && morningHours.length > 0 && (
          <div className="timpicker--group">
            <div className="timpicker--heading">
              <b>Morning</b>
            </div>
            <div className="timpicker--hours">
              {this.renderHours(morningHours)}
            </div>
          </div>
        )}

        {afternoonHours && afternoonHours.length > 0 && (
          <div className="timpicker--group" style={{ marginTop: 30 }}>
            <div className="timpicker--heading">
              <b>Afternoon</b>
            </div>
            <div className="timpicker--hours">
              {this.renderHours(afternoonHours)}
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default Timepicker;
